module.exports = __webpack_public_path__ + "img/companybg.bc0985f3.png";